import * as loadQueueHelper from '../../../../shared/js/document/load-queue'
import Autocomplete from '../../../../shared/modules/components/autocomplete/main'
import JSONFetcher from '../../../../shared/js/helpers/json-fetcher'
import Collection from '../../../../shared/js/core/collection'
import { FILTER_TYPES } from '../../../../shared/js/data/filters/config'
import DestinationsCollection from '../../../../shared/js/data/filters/destinations/destinations-collection'
import { decodeHtml } from '../../../../shared/js/helpers/string'

loadQueueHelper.add(function () {
  initTriviaAutocomplete()
  initDestinationsAutocomplete()
  initLiveAutocomplete()
  initLiveTwitterAutocomplete()
}, 2)

const initTriviaAutocomplete = () => {
  const triviaElement = document.getElementById('trivia-autocomplete')
  if (!triviaElement) return

  // Get and process the some random questions from open trivia dataBase
  window.fetch('https://opentdb.com/api.php?amount=50', {})
    .then(data => data.json())
    .then(data => Promise.resolve(
      data.results
        .map(result => ({
          question: decodeHtml(result.question),
          category: decodeHtml(result.category)
        })
        )))
    // Initialize the autocomplete
    .then(questions => {
      const triviaCollection = new Collection(questions)
      const triviaAutocomplete = new Autocomplete(triviaElement, {
        data: triviaCollection,
        searchAttributes: ['question', 'category'],
        displayAttributes: ['question', 'category'],
        emptyShownResults: false
      })
      triviaAutocomplete.events.on('submit', (selection) => console.log('Submit', selection))
      console.log('trivia autocomplete demo:', triviaAutocomplete)
    })
}

const initDestinationsAutocomplete = () => {
  const destinationsAutocompleteElement = document.getElementById('destinations-autocomplete')
  const destinationsAutocompleteElement2 = document.getElementById('destinations-autocomplete-2')
  const betterDestinationsAutocompleteElement = document.getElementById('better-destinations-autocomplete')

  if (!destinationsAutocompleteElement || !betterDestinationsAutocompleteElement) return

  const quickSearchRequest = new JSONFetcher({ src: '../assets/api/quick-search.json' })
  quickSearchRequest.fetch().then(data => {
    const destinationsData = data.filters.find(filter => filter.type === FILTER_TYPES.DESTINATION).values
    const destinations = new DestinationsCollection(destinationsData)

    // Init the destinations autoComplete
    if (destinationsAutocompleteElement) {
      const destinationsAutocomplete = new Autocomplete(destinationsAutocompleteElement, {
        data: destinations,
        searchAttributes: ['caption'],
        displayAttributes: ['caption', 'type', 'count'],
        emptyShownResultsData: destinations.getSortedCountriesAndRegions()
      })
      destinationsAutocomplete.events.on('submit', (selection) => console.log('Submit', selection))
      console.log('destinations autocomplete demo:', destinationsAutocomplete)
    }

    // Init the destinations autoComplete2
    if (destinationsAutocompleteElement2) {
      const destinationsAutocomplete2 = new Autocomplete(destinationsAutocompleteElement2, {
        data: destinations,
        searchAttributes: ['caption'],
        displayAttributes: ['caption', 'type', 'count'],
        emptyShownResultsData: destinations.getSortedCountriesAndRegions()
      })
      destinationsAutocomplete2.events.on('submit', (selection) => console.log('Submit', selection))
      console.log('destinations autocomplete demo:', destinationsAutocomplete2)
    }

    // Init the better destinations autoComplete
    if (betterDestinationsAutocompleteElement) {
      const betterDestinationsAutocomplete = new Autocomplete(betterDestinationsAutocompleteElement, {
        data: destinations,
        searchAttributes: ['caption'],
        emptyShownResultsData: destinations.getSortedCountriesAndRegions()
      })
      // Set the icons matching types
      const destinationIcons = {
        country: 'earth',
        region: 'umbrella',
        city: 'destination'
      }
      // Improve the resultElement
      betterDestinationsAutocomplete.getResultHtml = function (result) {
        return `
<li class="c-autocomplete__result" data-destination-type="${result.getAttribute('type')}" aria-selected="false" data-cid="${result.cid}">
  <span data-attribute="caption">
          ${result.getAttribute('caption').replace(this.currentSearch.termRegExp, '<mark>$1</mark>')}
          <span data-attribute="count">${result.getAttribute('count').toString()}</span>
  </span>
  <div class="c-autocomplete__results-parents">
    ${result.getParentModels().map(parent => `
      <span data-attribute="parent" data-parent-type="${parent.getAttribute('type')}">
        ${parent.getAttribute('caption')}
      </span>
    `).join('')}
  </div>
  <i class="m-icon m-icon--${destinationIcons[result.getAttribute('type')]}"></i>
</li>`
      }

      betterDestinationsAutocomplete.events.on('submit', (selection) => console.log('Submit', selection))
      console.log('better destinations autocomplete demo:', betterDestinationsAutocomplete)
    }
  })
}

const initLiveAutocomplete = () => {
  const liveElement = document.getElementById('live-autocomplete')
  if (!liveElement) return

  const liveAutocomplete = new Autocomplete(liveElement, {
    data: new Collection([]),
    // url: 'https://cors-anywhere.herokuapp.com/https://www.sunweb.se/api/sitecore/FreeTextSearchApi/GetFreeTextSearchApi',
    url: 'https://www.sunweb.se/api/sitecore/FreeTextSearchApi/GetFreeTextSearchApi',
    urlSearchParam: 'query',
    urlParams: {
      contextitemid: '53e1f284-6091-4908-8039-6b50b3561109'
    },
    searchAttributes: ['caption'],
    displayAttributes: ['caption'],
    emptyShownResults: false
  })
  liveAutocomplete.processFreshData = (data) => data.results || []
  liveAutocomplete.events.on('submit', (selection) => console.log('Submit', selection))
  console.log('live autocomplete demo:', liveAutocomplete)
}

const initLiveTwitterAutocomplete = () => {
  const liveElement = document.getElementById('live-twitter-autocomplete')
  if (!liveElement) return

  const liveAutocomplete = new Autocomplete(liveElement, {
    data: new Collection([]),
    // url: 'https://cors-anywhere.herokuapp.com/https://www.sunweb.se/api/sitecore/FreeTextSearchApi/GetFreeTextSearchApi',
    url: 'https://typeahead-js-twitter-api-proxy.herokuapp.com/demo/search',
    urlSearchParam: 'q',
    searchAttributes: ['name', 'screenName'],
    displayAttributes: ['screenName', 'name', 'location'],
    emptyShownResults: false,
    urlConfig: {
      mode: 'cors',
      headers: {
        Accept: 'application/json, text/javascript, */*; q=0.01',
        'Accept-Encoding': 'gzip, deflate, br',
        'Accept-Language': 'en-US,en;q=0.5',
        Connection: 'keep-alive',
        Host: 'typeahead-js-twitter-api-proxy.herokuapp.com',
        Origin: 'https://twitter.github.io',
        Referer: 'https://twitter.github.io/typeahead.js/'
      }
    }
  })
  liveAutocomplete.processFreshData = (data) => data.map(user => ({
    name: user.name,
    screenName: user.screen_name,
    location: user.location
  })) || []
  liveAutocomplete.events.on('submit', (selection) => console.log('Submit', selection))
  console.log('live autocomplete demo:', liveAutocomplete)
}

// Removed because the generated amount of data is too large for mobile devices.
/* const initNlTransportAutocomplete = () => {
  const nlTransportElement = document.getElementById('nl-transport-autocomplete')
  if (!nlTransportElement) return

  // Get and process the stop area codes from The Netherlands
  window.fetch('https://cors-anywhere.herokuapp.com/http://v0.ovapi.nl/stopareacode', {})
    .then(stopAreaCodes => stopAreaCodes.json())
    .then(stopAreaCodes => Promise.resolve(
      Object.values(stopAreaCodes)
        .map(stopArea => ({
            name: stopArea['TimingPointName'],
            town: stopArea['TimingPointTown']
          })
        )))
    // Initialize the autocomplete
    .then(stopAreaCodes => {
      const nlTransportCollection = new Collection(stopAreaCodes)
      const nlTransportAutocomplete = new Autocomplete(nlTransportElement, {
        data: nlTransportCollection,
        searchAttributes: ['name', 'town'],
        displayAttributes: ['name', 'town'],
        emptyShownResults: false
      })
      nlTransportAutocomplete.events.on('submit', (selection) => console.log('Submit', selection))
      console.log('nl transport autocomplete demo:', nlTransportAutocomplete)
    })
} */
